import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import 'react-toastify/dist/ReactToastify.css';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// Generate a nonce
const generateNonce = () => {
  return btoa(Math.random().toString(36).substring(2, 15));
};

const nonce = generateNonce();  // Generate a nonce

// Set the nonce as an attribute on the root element for use in CSP
const root = ReactDOM.createRoot(document.getElementById('root'));
document.getElementById('root').setAttribute('data-nonce', nonce);
root.render(
  <BrowserRouter>
  <Provider store={store}>
      <Routes>
        <Route path="/*" element={<App />} />
      </Routes>
      </Provider>
  </BrowserRouter>
);

reportWebVitals();
